// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"page_mainBox__w1e1H","insideBox":"page_insideBox__EQG7s"};